import Cookie from 'js-cookie'
import {STORAGE_DOMAIN} from '../_config'

export const CookiesGet = data => Cookie.get(data)

export const CookiesSet = (key, value, options = {}) =>
  Cookie.set(key, value, { ...options, domain: STORAGE_DOMAIN })



// WEBPACK FOOTER //
// ./src/core/helpers.js